module.exports = __webpack_public_path__ + "img/freestyle_rhino.60f1a73e.png";